import mongoose from "mongoose";
import { YesNo } from "../general";
import { AddressBody } from "../address";
// import { MergerAcquisition } from "./mergerAcquisition";

export enum Tier {
    System = "system",
    SubSystem = "sub-system",
    Unit = "unit",
    Component = "component",
}

export enum InitFunding {
    FounderFunded = "Founder-Funded",
    VentureCapital = "Venture Capital",
    Bank = "Bank",
    Kickstarter = "Kickstarter",
    Government = "Government",
    Other = "Other",
}

export enum OwnershipType {
    Public = "public",
    Private = "private",
    GonvernmentControlled = "gonvernment controlled",
    Other = "other",
}

export enum SubsidiaryType {
    No = "No",
    Partially = "Partially owned subsidiary",
    Yes = "Wholly owned subsidiary",
}

export enum StabilityRating {
    BootstrapOperation = "Bootstrap Operation",
    AccessibleFunding = "Accessible Funding",
    WellEstablished = "Well Established",
}

export enum OrganizationType {
    Corp = "Corp (S or C)",
    LLC = "LLC",
    NonProfit3 = "Non-Profit 501(c)(3)",
    NonProfit6 = "Non-Profit 501(c)(6) - Trade Association",
    Proprietorship = "Proprietorship",
    SpaceAgency = "Space Agency",
    SRL = "S.R.L",
    LTD = "LTD",
    StateOwnedEnterprise = "State Owned Enterprise",
    University = "University",
    Unknown = "Unknown",
}

export enum EnvironmentalTest {
    No = "No",
    NA = "n/a",
    AcousticTesting = "Acoustic Testing",
    AnechoicTesting = "Anechoic Testing",
    Cryo = "Cryo",
    DurometerHardness = "Durometer & Hardness",
    EDS = "Energy Dispersive Spectroscope (EDS)",
    EMI = "EMI/EMC",
    ESD = "ESD Simulator",
    GC = "Gas Chromatograph / Mass Spectrometer (GC/MS)",
    MechanicalFatigue = "Mechanical Fatigue",
    PneumaticShock = "Pneumatic Shock",
    RandomVibration = "Random Vibration",
    STEM = "Simulated Transmission Electron Microscope (STEM)",
    ScanningElectronMicroscope = "Scanning Electron Microscope",
    TemperatureHumidity = "Temperature Humidity",
    ThermalCycle = "Thermal Cycle",
    ThermalShock = "Thermal Shock",
    ThermalVacuum = "Thermal Vacuum",
    VibrationTest = "Vibration Test",
    XRay = "X-ray Inspection",
}

export enum ManufactureInternal {
    InternalManufacture = "Internal Manufacture",
    MixedInternalAndOutsourced = "Mixed Internal and Outsourced",
    AllOutsourced = "All Outsourced",
}

export enum Customer {
    Academia = "Academia",
    DomesticCommercialEntities = "Domestic Commercial Entities",
    EuropeanGovernments = "European Governments",
    Financial = "Financial",
    Institutions = "Institutions",
    InternationalCommercialEntities = "International Commercial Entities",
    OtherGovernments = "Other Governments",
    UnitedStatesGovernment = "United States Government",
}

export enum AddressDescription {
    SatelliteOffice = "satellite office",
    International = "international",
    Mailing = "mailing",
}

export enum OrganizationStatus {
    Unknown = "Unknown",
    Active = "Active",
    InActive = "In-Active",
}

export enum OrganizationSize {
    Large = "Large",
    Medium = "Medium",
    Small = "Small",
}

export interface Address extends AddressBody {
    description: AddressDescription;
}

export interface Coordinates {
    latitude: number;
    longitude: number;
}

export interface PhoneNumber {
    comments: string;
    phoneNumber: string;
    type: PhoneNumberType;
}

export enum PhoneNumberType {
    General = "General",
    Headquarters = "Headquarters",
    Information = "Information",
    Sales = "Sales",
    SatelliteOffice = "Satellite Office",
    Support = "Support",
}

export interface Email {
    comments: string;
    email: string;
    type: EmailType;
}

export enum EmailType {
    Information = "Information",
    General = "General",
    Other = "other",
    Sales = "Sales",
    Support = "Support",
}

export interface PointOfContact {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    email: string;
    address: Address;
    title: string;
    publicInfo: boolean;
}

export interface CheckList {
    contactCompanyComments?: string;
    contactCompanyDate?: Date;
    contactCompanyUserId?: mongoose.Types.ObjectId;
    privateComments?: string;
    publicRecordsComments?: string;
    publicRecordsDate?: Date;
    publicRecordsUserId?: mongoose.Types.ObjectId;
    published?: boolean;
    regulatoryRecordsComments?: string;
    regulatoryRecordsDate?: Date;
    regulatoryRecordsUserId?: mongoose.Types.ObjectId;
    socialMediaComments?: string;
    socialMediaDate?: Date;
    socialMediaUserId?: mongoose.Types.ObjectId;
    updatedAt?: Date;
    websiteComments?: string;
    websiteDate?: Date;
    websiteUserId?: mongoose.Types.ObjectId;
}

export interface CurrentPartner {
    organizationId?: string;
    name: string;
}

export enum QuintileSizeOptions {
    Small = "Small",
    Medium = "Medium",
    Large = "Large",
}

export enum CustomerFocus {
    Commercial = "Commercial",
    Government = "Government",
    DualUse = "Dual Use",
}

export enum SpaceFocus {
    FullCompany = "Full Company",
    Division = "Division/Unit",
    Diverse = "Diverse",
}

export enum PublicPrivate {
    Public = "Public",
    Private = "Private",
}

export enum Currencies {
    USD = "USD",
    CAD = "CAD",
    EUR = "EUR",
    GBP = "GBP",
    AUD = "AUD",
    JPY = "JPY",
    KRW = "KRW",
    NOK = "NOK",
    THB = "THB",
    SEK = "SEK",
}

export enum Months {
    January = "January",
    Febuary = "Febuary",
    March = "March",
    April = "April",
    May = "May",
    June = "June",
    July = "July",
    August = "August",
    September = "September",
    October = "October",
    December = "December",
}

export enum YearlyFinancialType {
    Actual = "Actual",
    Projection = "Projection",
}

export interface YearlyFinancialData {
    capex?: string;
    ebitda?: string;
    ebitdaMargin?: string;
    grossProfit?: string;
    revenue?: string;
    type?: YearlyFinancialType;
    year: string;
}

export interface Naics {
    naicsCode: string;
    naicsDescription: string;
    isPrimary: boolean;
}

export interface Psc {
    pscCode: string;
    pscDescription: string;
}

export interface KeyPerformanceIndicators {
    cash?: string;
    companyStatus?: PublicPrivate;
    currency?: Currencies;
    debt?: string;
    employeeBase?: string;
    enterpriseValue?: string;
    exchange?: string;
    fdSharesOutstanding?: string;
    financialDataType?: string;
    fiscalYearMonth?: string;
    lastFinancingEvent?: string;
    lastFinancingEventSize?: string;
    lastFinancingEventType?: string;
    leverage?: string;
    marketCapitalization?: string;
    netProfit?: string;
    netProfitMargin?: string;
    ownership?: OwnershipType;
    primaryCustomerFocus?: CustomerFocus;
    revenue?: string;
    sharePrice?: string;
    sizeQuintile?: QuintileSizeOptions;
    spaceFocus?: SpaceFocus;
    ticker?: string;
    valuationNotes?: string;
    yearlyFinancialData?: YearlyFinancialData[];
}

export interface AssessmentParameters {
    capabilityGrowthRate?: number;
    demandGrowthPotential?: number;
    diversityOfOfferings?: number;
    externalFactorsNegative?: string[];
    externalFactorsPositive?: string[];
    gameChangersNegative?: string[];
    gameChangersPositive?: string[];
    technicalOverall?: number;
    technicalRisksNegative?: string[];
    technicalRisksPositive?: string[];
    technicalRiskProfile?: number;
    technologyMarketFit?: number;
    testingCapabilityNegative?: string[];
    testingCapabilityPositive?: string[];
    topAccelerantsNegative?: string[];
    topAccelerantsPositive?: string[];
}

export interface Organization {
    academiaProbs?: string;
    acquired?: Date;
    acquirer?: string;
    acquisitionAmount?: string;
    addresses?: Address[];
    advertisingInterest?: YesNo;
    applicationTags?: string[];
    approvedCountry?: string[];
    assessmentParameters?: AssessmentParameters;
    bldgImagelink?: string;
    briefUpload?: string;
    checkList?: CheckList;
    city?: string;
    competitors?: string;
    conductRandD?: YesNo;
    coordinates?: Coordinates | null;
    corpCatalogs?: string;
    corpGoals?: string;
    corpLogo?: string;
    corpOwners?: string;
    corpProfit?: string;
    corpRevenue?: string;
    corpStandards?: string[];
    country?: string;
    currentPartners?: CurrentPartner[];
    customers?: Customer[];
    dateYearFounded?: number;
    dateMonthFounded?: number;
    description?: string;
    duns?: string;
    emails?: Email[];
    environmentalTest?: EnvironmentalTest[];
    expertise?: string[];
    expertiseExplanation?: string;
    financialStabilityRating?: StabilityRating;
    foreignFunding?: string;
    foreignOwnership?: string;
    fundRandD?: YesNo;
    heritage?: string;
    hiring?: YesNo;
    hiringHelp?: YesNo;
    identifyManufacture?: YesNo;
    identifyPartners?: YesNo;
    individualSpecialExpertise?: string;
    industryChallenges?: string;
    industryChanges?: string;
    initFunding?: InitFunding[];
    intlSales?: YesNo;
    investmentsAndFunding?: string;
    isBedrock?: boolean;
    keyPerformanceIndicators?: KeyPerformanceIndicators;
    licenseTech?: YesNo;
    manufactureInternal?: ManufactureInternal[];
    naics?: Naics[];
    nameBODmembers?: string[];
    newReqs?: YesNo;
    notifyRandD?: YesNo;
    numBOD?: number;
    numEmployees?: number;
    numVolunteers?: number;
    operatingRegimeTags?: string[];
    openToPartners?: YesNo;
    organizationDBA?: string;
    organizationid: string;
    organizationName: string;
    organizationSize?: OrganizationSize;
    organizationType?: OrganizationType;
    otherURLs?: string;
    ownership?: OwnershipType;
    parentOrganizationName?: string;
    phoneNumbers?: PhoneNumber[];
    pointOfContact?: PointOfContact[];
    productTags?: string[];
    psc?: Psc[];
    seekInvest?: YesNo;
    seekSale?: YesNo;
    selfDescription?: string;
    sellExportControlProds?: YesNo;
    smallBusiness?: YesNo;
    serviceTags?: string[];
    socialFacebook?: string;
    socialFlickr?: string;
    socialInstagram?: string;
    socialLinkedIn?: string;
    socialLivestream?: string;
    socialTwitter?: string;
    socialYouTube?: string;
    standardsUpdates?: string;
    state?: string;
    status: OrganizationStatus;
    streetAddr?: string;
    subsidiary?: SubsidiaryType;
    subsidiaryList?: string;
    targetCustomers?: string;
    testRanges?: string;
    tiers?: Tier[];
    ufFederalCage?: string;
    universityOfChoice?: string;
    upcomingProducts?: string;
    updatedAt: Date;
    veteranOwned?: YesNo;
    verticalIntegration?: string;
    wantIntlSales?: YesNo;
    webAddr?: string;
    zipcode?: string;
}
